import { createFileRoute } from '@tanstack/react-router';

import { SupplierInvoicesPage } from '@/features/supplier/invoices-page';

export const Route = createFileRoute('/_app/supplier/$orgId/invoices')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierInvoicesPage {...params} />;
}
